<template>
  <el-form ref="form"
           :model="form"
           size="medium"
           label-width="140px">
    <div class="medium"
         style="width: auto">
      <el-form-item label="抵扣状态">
        <template slot-scope="scope">
        <span v-for="item in options.deduction_status"
              v-if="form.deduction_status * 1 === item.value * 1">{{ item.label }}</span>
        </template>
      </el-form-item>

      <el-form-item label="抵扣日志">
        <template>
        <span>
          <b>可用抵扣金额：</b>{{ symbol }}{{ form.available_deduct_amount | seperateThousandsToFixed(2) }}
          <b>冻结抵扣金额：</b>{{ symbol }}{{ form.freeze_deduct_amount | seperateThousandsToFixed(2) }}
          <b>已抵扣金额：</b>{{ symbol }}{{ form.deducted_amount | seperateThousandsToFixed(2) }}
        </span>
        </template>
      </el-form-item>
      <el-divider></el-divider>

      <!--     抵扣条目详情       -->
      <template v-for="(deductItem, deductIndex) in form.deduction_detail">
        <el-form size="medium"
                 label-width="120px">
          <div class="medium"
               style="width: auto">
            <el-form-item :label="`抵扣条目 ` + (deductIndex+1)">

              <el-form-item label="">
                <b>项目名称/编号：</b>{{ deductItem.project.name }}/{{ deductItem.project.number }} <br>
                <b>抵扣含税金额：</b>{{ symbol }}{{ deductItem.deduction_amount | seperateThousandsToFixed(2) }}
              </el-form-item>

              <el-form-item label="条目操作日志">
                <template v-for="(logItem, index) in deductItem.log">
                  <span>{{ logItem.created_at }} {{ logItem.admin_name }}/{{ logItem.admin_real_name }} {{ logItem.desc }}<br></span>
                </template>
              </el-form-item>

              <el-form-item label="审批状态">
                <div v-for="item in options.deduction_detail_status">
                  <span v-if="deductItem.status * 1 === item.value * 1"
                        :style="{color: item.color}">
                    {{ item.label }}</span>
                </div>
              </el-form-item>

              <el-form-item label="抵扣申请附件"
                            prop="attached_file">
                <AttachedFileList :files="deductItem.attached_file"/>
              </el-form-item>

              <!--      条目审批      -->
              <el-form-item label="条目驳回原因"
                            v-if="isDeductBtnShow(deductItem)">
                <el-input v-model="deductItem.reason"
                          @input="deductReasonChange()"
                          placeholder="抵扣条目驳回时请填写，通过无需填写"></el-input>
              </el-form-item>

              <el-form-item>
                <div style="float: right;padding: 20px 30px 0 0;">
                  <el-button type="success"
                             v-if="isDeductBtnShow(deductItem)"
                             @click="deductPass(deductItem, deductIndex)">{{ deductPassBtnText(deductItem) }}
                  </el-button>
                  <el-button type="danger"
                             v-if="isDeductBtnShow(deductItem)"
                             @click="deductReject(deductItem, deductIndex)">{{ deductRejectBtnText(deductItem) }}
                  </el-button>
                  <el-button type="danger"
                             v-if="isAbandonDeductBtnShow(deductItem)"
                             @click="deductAbandon(deductItem, deductIndex)">放弃抵扣
                  </el-button>
                </div>
              </el-form-item>
            </el-form-item>
            <el-divider></el-divider>
          </div>
        </el-form>
      </template>
      <!--   抵扣条目详情结束     -->
    </div>
  </el-form>

</template>

<script>
import AttachedFileList from './AttachedFileList'

export default {
  components: {
    AttachedFileList
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
      options: state => state.invoiceApply.options,
      statusEnum: state => state.customerProjectcost.statusEnum,
    }),
  },
  data () {
    return {
      symbol: '￥',
    }
  },
  methods: {
    isAbandonDeductBtnShow (deductItem) {
      // 待BU审批，且发起人访问显示放弃按钮
      if (this.user.id * 1 === this.form.initiator * 1) {
        return deductItem.status * 1 === 1
      }
      return false
    },
    isDeductBtnShow (deductItem) {
      if (this.form.status * 1 !== 7) {
        return false
      }
      // 超管
      if (this.user.usertype * 1 === 1) {
        // 状态参见 deduction_detail_status
        return [1, 2].includes(deductItem.status * 1)
      }
      // bu审批人
      if (deductItem.status * 1 === 1 && this.form.bu_approver * 1 === this.user.id * 1) {
        return true
      }
      // 财务审批人或财务管理员
      if (deductItem.status * 1 === 2 && this.user.usertype * 1 === 5) {
        return true
      }
      return false
    },
    deductPassBtnText (deductItem) {
      if (deductItem.status * 1 === 1) {
        return 'BO 审批通过'
      } else if (deductItem.status * 1 === 2) {
        return '财务审批通过'
      } else {
        return false
      }
    },
    deductRejectBtnText (deductItem) {
      if (deductItem.status * 1 === 1) {
        return 'BO 审批驳回'
      } else if (deductItem.status * 1 === 2) {
        return '财务审批驳回'
      } else {
        return false
      }
    },
    deductAbandon (deductItem, deductIndex) {
      this.$confirm('即将放弃本抵扣申请，是否确认？', '放弃抵扣申请确认').then(() => {
        request.common('deductItemApproveAbandon', {id: deductItem.id}).then((res) => {
          this.form.deduction_detail[deductIndex].status = res.data.status
          this.form.deduction_detail[deductIndex].status = res.data.status
          this.$confirm('放弃申请成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
            this.$router.back()
          }).catch(() => {
            this.$forceUpdate()
          })
        })
      })
    },
    deductPass (deductItem, deductIndex) {
      const api = deductItem.status * 1 === 1 ? 'deductItemBuPass' : 'deductItemFinancePass'
      this.$confirm('即将通过本抵扣申请，是否确认？', '通过抵扣申请确认').then(() => {
        request.common(api, {id: deductItem.id}).then((res) => {
          this.form.deduction_detail[deductIndex].status = res.data.status
          this.$confirm('通过抵扣成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
            this.$router.back()
          }).catch(() => {
            this.$router.go(0)
          })
        })
      })
    },
    deductReject (deductItem, deductIndex) {
      let reason = this.form.deduction_detail[deductIndex].reason
      const api = deductItem.status * 1 === 1 ? 'deductItemBuReject' : 'deductItemFinanceReject'
      if (reason) {
        this.$confirm('即将驳回本抵扣申请，是否确认？', '驳回抵扣申请确认').then(() => {
          request.common(api, {id: deductItem.id, reason}).then((res) => {
            this.form.deduction_detail[deductIndex].status = res.data.status
            this.$confirm('驳回抵扣成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
              this.$router.back()
            }).catch(() => {
              this.$router.go(0)
            })
          })
        })
      } else {
        this.$alert('必须填写抵扣驳回原因', '提示', {
          type: 'error',
        })
      }
    },
    deductReasonChange () {
      this.$forceUpdate()
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceDeductLayout.vue